module.exports = __webpack_public_path__ + "static/media/circle_floorplan.6a1ae27d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/circle_floorplan.jpg
// module id = 203
// module chunks = 0